module.exports = global["React"] = require("-!.\\index.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?React!./node_modules/react/index.js-exposed
// module id = 545
// module chunks = 0 1